import type { QueryClient } from '@tanstack/react-query';
import type { Device } from '@types';
import { buildHydrateEntryFromConfiguration } from '../../research/packages/spectral-workspace/utils/buildHydrateEntryFromConfiguration';
import { getCachedSessionConfiguration } from '../../research/packages/spectral-workspace/queries/prefetchSessionConfigurations';
import type { HydrateSessionEntry } from '../../research/packages/spectral-workspace/hooks/useWorkspaceSessions';

export const buildGroupHydrateKey = (
  groupId: string,
  sessionIds: number[]
) => `${groupId}:${[...sessionIds].sort((a, b) => a - b).join(',')}`;

export const buildGroupHydrateEntries = ({
  queryClient,
  sessionIds,
  sensorDeviceLookup,
}: {
  queryClient: QueryClient;
  sessionIds: number[];
  sensorDeviceLookup?: Map<string, Device>;
}): { entries: HydrateSessionEntry[]; needsFetch: boolean } => {
  const entries: HydrateSessionEntry[] = [];
  let needsFetch = false;

  sessionIds.forEach(sessionId => {
    const cached = getCachedSessionConfiguration(queryClient, sessionId);
    if (cached) {
      entries.push(
        buildHydrateEntryFromConfiguration(
          sessionId,
          cached,
          sensorDeviceLookup
        )
      );
      return;
    }

    needsFetch = true;
    entries.push({
      sessionId,
      hasHrData: true,
      hasHrDataRepaired: false,
    });
  });

  entries.sort((left, right) => left.sessionId - right.sessionId);

  return { entries, needsFetch };
};
